import React from 'react';
import DashboardSidebar from '../DashboardSidebar/DashboardSidebar';
import ModeToggle from '../../containers/TopbarContainer/Topbar/TopbarDesktop/ModeToggle/ModeToggle';
import css from './DashboardLayout.module.css';

const DashboardLayout = ({ currentPage, role, children }) => {
  return (
    <div className={css.dashGrid}>
      <DashboardSidebar currentPage={currentPage} role={role} />
      <div className={css.dashContent}>
        {/* Surface the Hosting/Renting mode toggle on mobile dashboards.
            On desktop the toggle lives in the Topbar nav (TopbarDesktop)
            but the mobile topbar doesn't render it -- without surfacing
            it here, mobile users who both host and rent get stuck in
            whichever mode they landed in. The wrapper hides on desktop
            (≥1024px) so we don't double up. ModeToggle short-circuits
            for pure-renter users (canSwitchModes === false), so this
            renders as nothing for them. */}
        <div className={css.mobileModeToggle}>
          <ModeToggle />
        </div>
        {children}
      </div>
    </div>
  );
};

export default DashboardLayout;
